var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"k-field-wrapper",class:this.grid},[_c('VTextarea',_vm._g(_vm._b({attrs:{"label":_vm.translatedLabel,"rules":_vm.computedRules}},'VTextarea',_vm.fieldProps,false),_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }